import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { PipeModule } from "../../../../../../pipes/pipes.module";
import { CustomersService } from "../../../../../customer/services/customers.service";
import { CustomerSelectorPopoverItemModule } from "../customer-selector-popover-item/customer-selector-popover-item.module";
import { CustomerSelectorPopoverModule } from "../customer-selector-popover/customer-selector-popover.module";
import { CustomerSelectorComponent } from "./customer-selector.component";

const laComponents = [CustomerSelectorComponent];

@NgModule({
	declarations: laComponents,
	imports: [CustomerSelectorPopoverItemModule, CustomerSelectorPopoverModule, CommonModule, IonicModule, PipeModule],
	exports: laComponents,
	providers: [CustomersService]
})
export class CustomerSelectorModule {}
